import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-data-deletion',
    templateUrl: './data-deletion.component.html'
})
export class DataDeletionComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    	window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/data-deletion/data-deletion.component.ts